/**
 * 画面に出す人の名前（PRODUCT_DEV-1189）
 *
 * 名前は姓と名を分けずに1つの欄で登録しているので、間のスペースが全角・半角・無しで混ざる
 * （dev では 39 人中 9 人が全角）。画面では **姓と名の間を半角スペース1つ**にそろえる
 * （`by 山田 太郎`。2026-10-22 ユーザ決定・DESIGN.md「メタ情報の文法」）。
 *
 * - 表示専用。保存されている値は変えない（名前で突き合わせる処理には使わない）
 * - スペースの無い名前（`山田太郎`）はそのまま。姓と名の切れ目は推測しない
 */
export const displayPersonName = (name: string): string =>
  name.replace(/[ 　]+/g, " ").trim();
